import { Layout, MenuProps } from 'antd';
import { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import SidebarContent from '../SideBar/SidebarContent';
import './style.scss';
import { STORAGE } from '../../constants/Storage';

const { Content, Sider } = Layout;

interface IMainAppProp {
  menuItems?: MenuProps['items'];
  infoDropdownItems?: MenuProps['items'];
  extraTopbar?: ReactNode;
}

const MainApp = (props: IMainAppProp) => {
  // Check if user is logged in
  const isLoggedIn = !!localStorage.getItem(STORAGE.TOKEN);

  return (
    <Layout className="custom_layout" hasSider={isLoggedIn}>
      {isLoggedIn && (
        <Sider trigger={null} collapsible width="240px">
          <SidebarContent menuItems={props.menuItems} />
        </Sider>
      )}
      <Layout>
        <Content>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainApp;
